import React, { useEffect, useState } from "react";
import {
  blackColor,
  blackShade19,
  blackShade21,
  blueColor04,
  greenColor04,
  regiterSuccessCardBorder,
  whiteColor,
  yellowShade03,
} from "../../configs/styles/muiThemes";
import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import moment from "moment";
import {
  exportToExcel,
  exportToExcelCatalogPartnerData,
} from "./inventoryBulkUpdateHelper";
import InventoryDetailsTable from "./components/InventoryDetailsTable";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import SearchInfoCard from "./components/SearchInfoCard";

const DownloadInventoryDetails = ({
  isCatalogPartner,
  catalogPartner,
  productDetails,
  businessName,
  onUpload,
  gotoReview,
  searchQuery,
  setSearchQuery,
  handleSearch,
  applyONDCFilter,
  isClearFilter,
  setIsClearFilter,
  isClearSearch,
  setIsClearSearch,
  filterType,
  setFilterType,
  clearSearchFilter,
  ondcDropdownData,
  selectedOndcCategory,
  setSelectedOndcCategory,
  selectedOndcSubCat,
  setSelectedOndcSubCat,
  refreshProductList,
  draftInventoryData,
}) => {
  const [productList, setProductList] = useState([]);
  const [selectedRows, setSelectedRows] = useState(0);
  const [currentPage, setCurrentPage] = useState("select-action");
  const [isDownloaded, setIsDownloaded] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const onDownloadClick = async () => {
    if (isDownloaded) return;

    setErrorMsg("");
    if (productList?.every((item) => !item.isSelected)) {
      setErrorMsg("Select atleast one row to download excel");
      return;
    }

    setIsDownloaded(true);

    const selectedProducts = productList?.filter((item) => item?.isSelected);

    // exportToExcel(
    //   selectedProducts,
    //   `${businessName}_Inventory_Details_${moment().format("Do_MM_YYYY")}`,
    //   businessName
    // );

    if (isCatalogPartner) {
      exportToExcelCatalogPartnerData(
        selectedProducts,
        `${businessName}_Inventory_Details_${moment().format("Do_MM_YYYY")}`,
        businessName
      );
    } else {
      exportToExcel(
        selectedProducts,
        `${businessName}_Inventory_Details_${moment().format("Do_MM_YYYY")}`,
        businessName
      );
    }

    setTimeout(() => {
      setIsDownloaded(false);
      setCurrentPage('select-action')
    }, 2000);
  };

  // Handle Select All Product
  const selectAllProductRows = (isSelected) => {
    const allProducts = productList?.map((item) => ({
      ...item,
      isSelected: isSelected ? true : false,
    }));

    const selectedCount = allProducts?.filter(
      (item) => item?.isSelected
    ).length;

    setProductList((prevState) => allProducts);
    setSelectedRows(selectedCount);
    setErrorMsg("");
  };

  // Toggle Indiviual Row Selection
  const toggleProductRowSelect = (index, isSelected) => {
    const allProducts = [...productList];
    const productInfo = allProducts[index] || null;

    if (!productInfo) {
      setProductList(allProducts || []);
      return;
    }

    const updatedProductInfo = {
      ...productInfo,
      isSelected: !isSelected,
    };

    allProducts[index] = updatedProductInfo;

    const selectedCount = allProducts?.filter(
      (item) => item?.isSelected
    ).length;

    setProductList(allProducts || []);
    setSelectedRows(selectedCount);
    setErrorMsg("");
  };

  useEffect(() => {
    setProductList(productDetails?.length > 0 ? productDetails : []);

    return () => {};
  }, [productDetails]);

  return (
    <Box>
      {currentPage === "select-action" && (
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item md={5.5}>
              <Box>
                <Typography sx={styles.heading}>
                  Download Current{" "}
                  {isCatalogPartner ? "Pricing" : "Inventory/Pricing"} Details
                </Typography>
                <Typography sx={styles.subText}>
                  Download the latest{" "}
                  {isCatalogPartner ? "pricing" : "inventory/pricing"} data,
                  update details and upload seamlessly.
                </Typography>

                <Button
                  variant="contained"
                  disableElevation
                  startIcon={
                    <FileDownloadOutlinedIcon sx={{ fontSize: "24px" }} />
                  }
                  sx={styles.downloadBtn}
                  onClick={() => setCurrentPage("download")}
                >
                  DOWNLOAD EXCEL
                </Button>
              </Box>
            </Grid>

            <Grid item md={1}>
              <Typography
                sx={{
                  width: "35px",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 12,
                  fontWeight: 500,
                  color: blackColor,
                  borderRadius: "30px",
                  bgcolor: regiterSuccessCardBorder,
                  mt: 3,
                }}
              >
                OR
              </Typography>
            </Grid>

            <Grid item md={5.5}>
              <Box>
                <Typography sx={styles.heading}>
                  {draftInventoryData?.length > 0
                    ? `Continue With ${draftInventoryData?.length} Draft ${
                        isCatalogPartner ? "Pricing" : "Inventory/Pricing"
                      } Details`
                    : `Upload Updated ${
                        isCatalogPartner ? "Pricing" : "Inventory/Pricing"
                      } Details`}
                </Typography>
                {draftInventoryData?.length == 0 && (
                  <Typography sx={styles.subText}>
                    If you have an updated data sheet ready for upload, click
                    here
                  </Typography>
                )}

                <Button
                  variant="contained"
                  disableElevation
                  startIcon={
                    draftInventoryData?.length == 0 && (
                      <FileUploadOutlinedIcon sx={{ fontSize: "24px" }} />
                    )
                  }
                  endIcon={
                    draftInventoryData?.length > 0 && (
                      <ChevronRightRoundedIcon sx={{ fontSize: "24px" }} />
                    )
                  }
                  sx={styles.updateBtn}
                  onClick={() => {
                    if (draftInventoryData?.length == 0) {
                      onUpload();
                      return;
                    }

                    gotoReview();
                  }}
                >
                  {draftInventoryData?.length > 0 ? "Continue" : "UPLOAD EXCEL"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}

      {currentPage === "download" && (
        <Box>
          <InventoryDetailsTable
            isCatalogPartner={isCatalogPartner}
            catalogPartner={catalogPartner}
            productDetails={productList}
            selectAllProductRows={selectAllProductRows}
            toggleProductRowSelect={toggleProductRowSelect}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            handleSearch={handleSearch}
            applyONDCFilter={applyONDCFilter}
            isClearFilter={isClearFilter}
            setIsClearFilter={setIsClearFilter}
            filterType={filterType}
            setFilterType={setFilterType}
            isClearSearch={isClearSearch}
            setIsClearSearch={setIsClearSearch}
            clearSearchFilter={clearSearchFilter}
            ondcDropdownData={ondcDropdownData}
            selectedOndcCategory={selectedOndcCategory}
            setSelectedOndcCategory={setSelectedOndcCategory}
            selectedOndcSubCat={selectedOndcSubCat}
            setSelectedOndcSubCat={setSelectedOndcSubCat}
            refreshProductList={refreshProductList}
          />

          {errorMsg && (
            <Typography fontSize={11} fontWeight={500} color="red" m='6px 0 -28px 0'>
              {errorMsg}
            </Typography>
          )}

          {productList?.length > 0 && (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap={2}
            >
              <Button
                variant="contained"
                disableElevation
                sx={styles.backBtn}
                onClick={() => setCurrentPage("select-action")}
              >
                BACK
              </Button>

              <Button
                variant="contained"
                disableElevation
                sx={styles.downloadBtn}
                startIcon={
                  isDownloaded ? (
                    <CircularProgress size={14} color="inherit" />
                  ) : (
                    <FileDownloadOutlinedIcon sx={{ fontSize: "24px" }} />
                  )
                }
                onClick={onDownloadClick}
                // disabled={!productList?.some((item) => item.isSelected)}
              >
                {isDownloaded
                  ? "DOWNLOADING"
                  : `DOWNLOAD EXCEL FILE (${selectedRows} ${
                      selectedRows === 1 ? "Row" : "Rows"
                    })`}
              </Button>

              <Button
                variant="contained"
                disableElevation
                endIcon={
                  <ArrowForwardIosRoundedIcon
                    sx={{ fontSize: "15px !important" }}
                  />
                }
                sx={styles.updateBtn}
                onClick={onUpload}
              >
                NEXT
              </Button>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default DownloadInventoryDetails;

const styles = {
  heading: {
    fontSize: "14px",
    fontWeight: "600",
    color: blackShade19,
  },
  subText: {
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "18px",
    color: "rgb(118, 127, 145);",
    mb: "0px",
  },

  downloadBtn: {
    fontSize: 12,
    fontWeight: 600,
    color: whiteColor,
    backgroundColor: greenColor04,
    border: `1px solid ${greenColor04}`,
    borderRadius: "5px",
    p: "6px 16px",
    mt: 1.5,

    "&:hover": {
      color: greenColor04,
      backgroundColor: whiteColor,
    },
  },

  updateBtn: {
    fontSize: 12,
    fontWeight: 600,
    color: blackColor,
    backgroundColor: yellowShade03,
    border: `1px solid ${yellowShade03}`,
    borderRadius: "5px",
    p: "6px 16px",
    mt: 1.5,

    "&:hover": {
      color: yellowShade03,
      backgroundColor: whiteColor,
    },
  },

  backBtn: {
    fontSize: 12,
    fontWeight: 600,
    color: blackShade21,
    backgroundColor: whiteColor,
    border: `1px solid ${blackShade21}`,
    p: "6px 16px",
    mt: 1.5,

    "&:hover": {
      color: whiteColor,
      backgroundColor: blackShade21,
    },
  },
};
